import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vueResource from 'vue-resource'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Stepper } from 'vant'
import { Slider } from 'vant'
import { Progress, Rate } from 'vant'
import { Swipe, SwipeItem } from 'vant'
import { Lazyload, Dialog, Icon } from 'vant'
import { CountDown } from 'vant'
import { Image as VanImage } from 'vant'
import { List, Toast, Collapse, CollapseItem } from 'vant'
import { Tab, Tabs } from 'vant'
import { RadioGroup, Radio, Popup } from 'vant'
import { Checkbox, CheckboxGroup } from 'vant'
import VueSeamlessScroll from 'vue-seamless-scroll'
import WechatService from './views/WechatService'

Vue.component('WechatService', WechatService)



Vue.use(vueResource)
Vue.use(Vant)
Vue.use(VueSeamlessScroll)
Vue.use(Progress)
Vue.use(Stepper)
Vue.use(Slider)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(CountDown)
Vue.use(Lazyload)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(VanImage)
Vue.use(List)
Vue.use(Toast)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tab).use(Tabs)
Vue.use(Rate)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Popup)


Toast.setDefaultOptions({ duration: 700 })
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app']

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
